import { DisplayTransactionType } from '@features/bankTransactions/enums/displayTransactionType'

export const transactionTypeToTranslationKey: Record<DisplayTransactionType, string> = {
  [DisplayTransactionType.ATM]: 'bank_transactions.transaction_row.type.atm',
  [DisplayTransactionType.Card]: 'bank_transactions.transaction_row.type.card',
  [DisplayTransactionType.DirectDebit]: 'bank_transactions.transaction_row.type.direct_debit',
  [DisplayTransactionType.TransferIn]: 'bank_transactions.transaction_row.type.transfer_in',
  [DisplayTransactionType.TransferOut]: 'bank_transactions.transaction_row.type.transfer_out',
  [DisplayTransactionType.WalletTransfer]: 'bank_transactions.transaction_row.type.wallet_transfer',
  [DisplayTransactionType.Unknown]: 'bank_transactions.transaction_row.type.unknown',
}
